import React from 'react';
import { Box, Skeleton, Card, CardContent } from '@mui/material';

function CardSkeleton({ count = 3, imageHeight = 250, showTitle = true }) {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: { xs: 'column', md: 'row' }, 
      gap: 4, 
      justifyContent: 'center', 
      alignItems: 'center',
      flexWrap: 'wrap',
      width: '100%'
    }}>
      {Array.from(new Array(count)).map((_, index) => (
        <Card 
          key={index} 
          sx={{ 
            maxWidth: 400, 
            minWidth: 300, 
            borderRadius: 4, 
            boxShadow: 3,
          }}
        >
          {/* Image Skeleton */}
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height={imageHeight}
            sx={{ 
              borderRadius: '16px 16px 0 0',
              bgcolor: 'grey.300'
            }} 
          />
          
          {/* Content Skeleton */}
          <CardContent sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
            {showTitle && (
              <Skeleton 
                variant="rounded" 
                width="100%" 
                height={60}
                sx={{ 
                  bgcolor: 'grey.300',
                  borderRadius: '16px'
                }} 
              />
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

export default CardSkeleton;